import React from 'react'
import './CSS/gallery.css'
import gallery_1 from '../Assets/galary/gallery1.jpg'
import gallery_2 from '../Assets/galary/gallery2.jpg'
import gallery_3 from '../Assets/galary/gallery3.jpg'
import gallery_4 from '../Assets/galary/gallery4.jpg'
import gallery_5 from '../Assets/galary/gallery5.jpg'
import gallery_6 from '../Assets/galary/gallery6.jpg'
import gallery_7 from '../Assets/galary/gallery7.jpg'
import gallery_17 from '../Assets/galary/gallery17.jpg'
import gallery_9 from '../Assets/galary/gallery9.jpg'
import gallery_10 from '../Assets/galary/gallery10.jpg'
import gallery_11 from '../Assets/galary/gallery11.jpg'
import gallery_12 from '../Assets/galary/gallery12.jpg'
import gallery_13 from '../Assets/galary/gallery13.jpg'
import gallery_14 from '../Assets/galary/gallery14.jpg'
import gallery_15 from '../Assets/galary/gallery15.jpg'
import gallery_16 from '../Assets/galary/gallery16.jpg'


const Gallery = () => {
  return (
    <div className='gallery'>
       <div>
            <h2 className='gallery-heading'>Image Gallery of Completed Project with Maunacil Paints and Team</h2>

            <div className='image-contaimer'>
                <div className='image-gallery'>
                    <img  src={gallery_1} alt='' />
                </div>

                <div className='image-gallery'>
                    <img  src={gallery_4} alt='' />
                </div>

                <div className='image-gallery'>
                    <img  src={gallery_3} alt='' />
                </div>

                <div className='image-gallery'>
                    <img  src={gallery_2} alt='' />
                </div>

                 <div className='image-gallery'>
                    <img  src={gallery_5} alt='' />
                </div>

                 <div className='image-gallery'>
                    <img 
                     src={gallery_6} alt='' />
                </div>

                 <div className='image-gallery'>
                    <img  src={gallery_7} alt='' />
                </div>

                 <div className='image-gallery'>
                    <img  src={gallery_17} alt='' />
                </div>

                  <div className='image-gallery'>
                    <img  src={gallery_9} alt='' />
                </div>

                  <div className='image-gallery'>
                    <img  src={gallery_10} alt='' />
                </div>

                  <div className='image-gallery'>
                    <img  src={gallery_11} alt='' />
                </div>

                  <div className='image-gallery'>
                    <img  src={gallery_12} alt='' />
                </div>

                  <div className='image-gallery'>
                    <img  src={gallery_13} alt='' />
                </div>

                  <div className='image-gallery'>
                    <img  src={gallery_14} alt='' />
                </div>

                  <div className='image-gallery'>
                    <img  src={gallery_15} alt='' />
                </div>

                  <div className='image-gallery'>
                    <img  src={gallery_16} alt='' />
                </div>
            </div>

       </div>
    </div>
  )
}

export default Gallery
